import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Code, Users, TrendingUp, Building2, Wrench, ShoppingBag, Phone as PhoneIcon, Heart, Package, Factory, Truck, GraduationCap, Briefcase } from 'lucide-react';
import { getCategories, submitIndustryEnquiry } from '../services/api';
import toast from 'react-hot-toast';

const iconMap = { Code, Users, TrendingUp, Building2, Wrench, ShoppingBag, Phone: PhoneIcon, Heart, Package, Factory, Truck, GraduationCap, Briefcase };

export default function IndustrySolutions() {
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ name: '', company_name: '', email: '', phone: '', industry: '', requirement: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    getCategories().then(res => setCategories(res.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.industry || !form.requirement) {
      toast.error('Please fill all required fields');
      return;
    }
    setSubmitting(true);
    try {
      await submitIndustryEnquiry(form);
      toast.success('Enquiry submitted successfully!');
      setForm({ name: '', company_name: '', email: '', phone: '', industry: '', requirement: '' });
    } catch {
      toast.error('Failed to submit enquiry');
    }
    setSubmitting(false);
  };

  return (
    <>
      <div className="page-header">
        <h1>Industry Specific Solutions</h1>
        <p>Tailored recruitment solutions for every industry</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <span>Industry Solutions</span>
        </div>
      </div>

      <div className="section">
        <div className="container">
          <div className="section-header">
            <div className="badge">Industries We Serve</div>
            <h2>Recruitment Across Sectors</h2>
            <p>We have deep expertise in recruiting talent for diverse industries</p>
          </div>
          <div className="categories-grid">
            {categories.map(cat => {
              const Icon = iconMap[cat.icon] || Briefcase;
              return (
                <Link to={`/jobs?category=${cat.name}`} className="category-card" key={cat.id} style={{ textDecoration: 'none' }}>
                  <div className="category-icon"><Icon size={24} /></div>
                  <h3>{cat.name}</h3>
                  {cat.description && <span style={{ fontSize: '0.813rem', color: '#94a3b8' }}>{cat.description}</span>}
                </Link>
              );
            })}
          </div>
        </div>
      </div>

      <div className="section section-alt" style={{ background: 'white' }}>
        <div className="container" style={{ maxWidth: 720 }}>
          <div className="section-header">
            <div className="badge">Get In Touch</div>
            <h2>Industry Specific Enquiry</h2>
            <p>Tell us about your industry-specific recruitment needs</p>
          </div>
          <div className="form-card">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Your Name *</label>
                  <input type="text" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Company Name</label>
                  <input type="text" value={form.company_name} onChange={(e) => setForm({...form, company_name: e.target.value})} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email *</label>
                  <input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Phone *</label>
                  <input type="tel" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} required />
                </div>
              </div>
              <div className="form-group">
                <label>Industry *</label>
                <select value={form.industry} onChange={(e) => setForm({...form, industry: e.target.value})} required>
                  <option value="">Select Industry</option>
                  {categories.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Your Requirement *</label>
                <textarea value={form.requirement} onChange={(e) => setForm({...form, requirement: e.target.value})}
                  placeholder="Describe your industry-specific recruitment needs..." required />
              </div>
              <button type="submit" className="btn-submit" disabled={submitting}>
                {submitting ? 'Submitting...' : 'Submit Enquiry'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
